import propTypes, { string } from 'prop-types';

export const clientPropTypes = propTypes.shape({
  clientId: string.isRequired,
  name: string.isRequired,
  owner: string.isRequired,
});
